'use client'

import { useCallback, useContext } from 'react'
import ModalContext from '@/app/_providers/ModalProvider/ModalContext'
import { toAppError } from '@/utils/errors.utils'
import { ErrorType } from '@/types/errors.types'

const useHandleError = (): { handleError: (err: unknown, fallback?: ErrorType) => void } => {
  const { setErrorModal } = useContext(ModalContext)

  const handleError = useCallback((err: unknown, fallback: ErrorType = ErrorType.Connection): void => {
    const appErr = toAppError(err)
    if (appErr) {
      setErrorModal({ type: appErr.errorType, message: appErr.message, error: appErr })
      return
    }
    const error = err instanceof Error ? err : new Error(String(err))
    setErrorModal({ type: fallback, message: error.message, error })
  }, [setErrorModal])

  return { handleError }
}

export default useHandleError
